export function getTitle (state) {
  return state.application.title
}

export function getMessages (state) {
  if (state.application.messages.length !== 0) {
    return state.application.messages
  }
}
